// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main {
  display: block;
  height: calc(100dvh - var(--appbar-height));
  width: 100%;
}

app-navigation {
  background: rgba(0, 0, 0, 0.04);
}

app-scope {
  background: rgba(0, 0, 0, 0.08);
}

#appbar {
  padding: 0 !important;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
}
#appbar .right {
  justify-content: end;
}

.menu-button {
  margin: 0 12px !important;
  font-size: 14px;
}

.identity-breadcrumbs {
  margin-left: 10px;
  -webkit-user-select: none;
          user-select: none;
}
.identity-breadcrumbs .team,
.identity-breadcrumbs .project {
  cursor: pointer;
}
.identity-breadcrumbs .spacer {
  padding: 0 4px;
}

.sidenav-content {
  display: flex;
  justify-content: center;
  align-items: top;
  width: 100%;
  height: 100%;
  margin-right: 124px;
}

mat-sidenav-container {
  height: 100vh;
  -webkit-user-select: none; /* Safari */ /* Firefox */ /* IE10+/Edge */
  user-select: none; /* Standard */
}

.mat-mdc-list-item {
  height: 35px !important;
  border-left: 3px solid transparent;
}

.mat-expansion-panel-body {
  padding: 0 !important;
}

.popup-menu-item {
  width: 160px;
  font-size: 16px;
}

.popup-menu-item-static {
  width: 160px;
  font-size: 14px;
}

.bigIcon {
  width: 36px !important;
  height: 36px !important;
}

.biggerIcon {
  width: 30px !important;
  height: 30px !important;
  margin-right: 10px;
  font-size: 20px !important;
}

.menu-text {
  width: 100%;
  margin: auto;
  color: #90a4ae;
  font-size: 13px;
  text-align: left;
}

.menu-icon {
  padding-left: 4px;
  color: #90a4ae;
  font-weight: lighter;
  font-size: 20px;
}

.nohover:hover {
  background: unset;
  cursor: unset;
}

mat-divider.header {
  height: 20px;
  border-color: transparent;
}

.category {
  overflow: hidden;
  border-top: 1px solid grey;
}

.category .menu-text {
  padding-top: 8px;
  padding-bottom: 3px;
  font-weight: bold;
  font-size: 16px;
}

.category .menu-icon {
  padding-left: 5px;
}

mat-divider {
  margin-top: 5px;
  border-color: rgba(255, 255, 255, 0.5);
}

.uppercase {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
}

.mdc-tab {
  height: 2rem !important;
}

.mat-mdc-tab-group {
  width: 100%;
  background: rgba(0, 0, 0, 0.04);
}

.tab-label {
  width: 100%;
  padding-left: 20px;
}

.mdc-tab__text-label {
  font-size: 12px !important;
  font-weight: 500 !important;
  min-width: 120px !important;
  height: 32px !important;
  justify-content: center !important;
  align-items: center !important;
  white-space: nowrap !important;
  padding: 5px !important;
  opacity: 1 !important;
}

.close-button mat-icon {
  color: rgba(0, 0, 0, 0.5) !important;
  font-size: 14px;
}

.mdc-tab--active .mdc-tab__text-label .close-button mat-icon {
  color: rgb(0, 0, 0) !important;
}

.mdc-tab-indicator__content {
  border: unset !important;
}

.toolbar-spacer {
  flex: 1 1 auto;
}

.mat-expansion-panel-header-title,
.mdc-list-item__content {
  font-weight: 400;
  font-size: 14px;
}

.mat-expansion-panel-header-title .mat-icon,
.mdc-list-item__content .mat-icon {
  font-size: 18px;
  margin-right: 16px;
  height: initial;
  width: initial;
}

.mat-expansion-panel-header {
  padding: 0 5px !important;
  font-weight: bold;
}

.mat-expansion-panel-header.mat-expanded {
  height: 30px;
}

.sidenav-container {
  height: calc(100vh - var(--appbar-height));
}

.menu-group-header {
  padding: 15px 0 10px 16px;
  font-weight: 500;
  font-size: 14px;
}

.nested-list-item {
  -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
           supported by Chrome, Edge, Opera and Firefox */
  -webkit-touch-callout: none; /* iOS Safari */
}

.mat-mdc-tab:not(.mat-mdc-tab-disabled).mdc-tab--active .mdc-tab__text-label,
.mdc-list-item.mdc-list-item--active > .mdc-list-item__content {
  font-weight: 600 !important;
  color: unset !important;
}

.gray-icon {
  filter: grayscale(100%);
}

.column {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  flex-direction: row;
}

.menubar {
  float: right;
  margin-right: 10px;
}

app-root {
  display: flex;
  height: 100vh;
  width: 100vw;
}

.app-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,2CAAA;EACA,WAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,qBAAA;EACA,aAAA;EACA,mCAAA;AACF;AACE;EACE,oBAAA;AACJ;;AAGA;EACE,yBAAA;EACA,eAAA;AAAF;;AAGA;EACE,iBAAA;EACA,yBAAA;UAAA,iBAAA;AAAF;AAEE;;EAEE,eAAA;AAAJ;AAGE;EACE,cAAA;AADJ;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,yBAAA,EAAA,WAAA,EACA,YAAA,EACA,eAAA;EACA,iBAAA,EAAA,aAAA;AAFF;;AAKA;EACE,uBAAA;EACA,kCAAA;AAFF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,YAAA;EACA,eAAA;AADF;;AAIA;EACE,YAAA;EACA,eAAA;AADF;;AAIA;EACE,sBAAA;EACA,uBAAA;AADF;;AAIA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;AADF;;AAIA;EACE,iBAAA;EACA,aAAA;AADF;;AAIA;EACE,YAAA;EACA,yBAAA;AADF;;AAIA;EACE,gBAAA;EACA,0BAAA;AADF;;AAIA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,eAAA;EACA,sCAAA;AADF;;AAIA;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;AADF;;AAIA;EACE,uBAAA;AADF;;AAIA;EACE,WAAA;EACA,+BAAA;AADF;;AAIA;EACE,WAAA;EACA,kBAAA;AADF;;AAIA;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,kCAAA;EACA,8BAAA;EACA,8BAAA;EACA,uBAAA;EACA,qBAAA;AADF;;AAIA;EACE,oCAAA;EACA,eAAA;AADF;;AAIA;EACE,8BAAA;AADF;;AAIA;EACE,wBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;;EAEE,gBAAA;EACA,eAAA;AADF;;AAIA;;EAEE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AADF;;AAIA;EACE,yBAAA;EACA,iBAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,0CAAA;AADF;;AAIA;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,yBAAA,EAAA,WAAA,EACA,mBAAA,EACA,4BAAA,EACA,2BAAA;EACA,iBAAA,EAAA;yDAAA;EAEA,2BAAA,EAAA,eAAA;AADF;;AAIA;;EAEE,2BAAA;EACA,uBAAA;AADF;;AAIA;EACE,uBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,YAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,aAAA;EACA,YAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AADF","sourcesContent":["main {\n  display: block;\n  height: calc(100dvh - var(--appbar-height));\n  width: 100%;\n}\n\napp-navigation {\n  background: rgba(0, 0, 0, 0.04);\n}\n\napp-scope {\n  background: rgba(0, 0, 0, 0.08);\n}\n\n#appbar {\n  padding: 0 !important;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n\n  .right {\n    justify-content: end;\n  }\n}\n\n.menu-button {\n  margin: 0 12px !important;\n  font-size: 14px;\n}\n\n.identity-breadcrumbs {\n  margin-left: 10px;\n  user-select: none;\n\n  .team,\n  .project {\n    cursor: pointer;\n  }\n\n  .spacer {\n    padding: 0 4px;\n  }\n}\n\n.sidenav-content {\n  display: flex;\n  justify-content: center;\n  align-items: top;\n  width: 100%;\n  height: 100%;\n  margin-right: 124px;\n}\n\nmat-sidenav-container {\n  height: 100vh;\n  -webkit-user-select: none; /* Safari */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE10+/Edge */\n  user-select: none; /* Standard */\n}\n\n.mat-mdc-list-item {\n  height: 35px !important;\n  border-left: 3px solid transparent;\n}\n.mat-expansion-panel-body {\n  padding: 0 !important;\n}\n\n.popup-menu-item {\n  width: 160px;\n  font-size: 16px;\n}\n\n.popup-menu-item-static {\n  width: 160px;\n  font-size: 14px;\n}\n\n.bigIcon {\n  width: 36px !important;\n  height: 36px !important;\n}\n\n.biggerIcon {\n  width: 30px !important;\n  height: 30px !important;\n  margin-right: 10px;\n  font-size: 20px !important;\n}\n\n.menu-text {\n  width: 100%;\n  margin: auto;\n  color: #90a4ae;\n  font-size: 13px;\n  text-align: left;\n}\n\n.menu-icon {\n  padding-left: 4px;\n  color: #90a4ae;\n  font-weight: lighter;\n  font-size: 20px;\n}\n\n.nohover:hover {\n  background: unset;\n  cursor: unset;\n}\n\nmat-divider.header {\n  height: 20px;\n  border-color: transparent;\n}\n\n.category {\n  overflow: hidden;\n  border-top: 1px solid grey;\n}\n\n.category .menu-text {\n  padding-top: 8px;\n  padding-bottom: 3px;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.category .menu-icon {\n  padding-left: 5px;\n}\n\nmat-divider {\n  margin-top: 5px;\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.uppercase {\n  font-weight: bold;\n  font-size: 16px;\n  text-transform: uppercase;\n}\n\n.mdc-tab {\n  height: 2rem !important;\n}\n\n.mat-mdc-tab-group {\n  width: 100%;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.tab-label {\n  width: 100%;\n  padding-left: 20px;\n}\n\n.mdc-tab__text-label {\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  min-width: 120px !important;\n  height: 32px !important;\n  justify-content: center !important;\n  align-items: center !important;\n  white-space: nowrap !important;\n  padding: 5px !important;\n  opacity: 1 !important;\n}\n\n.close-button mat-icon {\n  color: rgba(0, 0, 0, 0.5) !important;\n  font-size: 14px;\n}\n\n.mdc-tab--active .mdc-tab__text-label .close-button mat-icon {\n  color: rgba(0, 0, 0, 1) !important;\n}\n\n.mdc-tab-indicator__content {\n  border: unset !important;\n}\n\n.toolbar-spacer {\n  flex: 1 1 auto;\n}\n\n.mat-expansion-panel-header-title,\n.mdc-list-item__content {\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.mat-expansion-panel-header-title .mat-icon,\n.mdc-list-item__content .mat-icon {\n  font-size: 18px;\n  margin-right: 16px;\n  height: initial;\n  width: initial;\n}\n\n.mat-expansion-panel-header {\n  padding: 0 5px !important;\n  font-weight: bold;\n}\n\n.mat-expansion-panel-header.mat-expanded {\n  height: 30px;\n}\n\n.sidenav-container {\n  height: calc(100vh - var(--appbar-height));\n}\n\n.menu-group-header {\n  padding: 15px 0 10px 16px;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.nested-list-item {\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Old versions of Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Non-prefixed version, currently\n                                supported by Chrome, Edge, Opera and Firefox */\n  -webkit-touch-callout: none; /* iOS Safari */\n}\n\n.mat-mdc-tab:not(.mat-mdc-tab-disabled).mdc-tab--active .mdc-tab__text-label,\n.mdc-list-item.mdc-list-item--active > .mdc-list-item__content {\n  font-weight: 600 !important;\n  color: unset !important;\n}\n\n.gray-icon {\n  filter: grayscale(100%);\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n}\n\n.menubar {\n  float: right;\n  margin-right: 10px;\n}\n\napp-root {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n}\n\n.app-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
